export default [
	{
		title: "Account",
		link: "/account",
		icon: 'profile'
	},

	// {
	// 	title: "Profile",
	// 	link: "/profile",
	// 	icon: 'profile'
	// },
	{
		title: "Dispatch",
		role: [ 0, 1, 2, 3, 4 ],
		icon: 'dispatch',
		child: [
			{ title: "Trips", link: "/trips", role: [ 0, 1, 2, 3, 4 ] },
		]
	},
	{
		title: "Safety",
		icon: 'safety',
		role: [ 0, 1, 3, 4 ],
		child: [
			{ title: "Logbooks", link: "/logbooks" },
			// { title: "Logbooks2", link: "/logbooks2" },
			{ title: "Employee work schedule", link: "/employee-work-schedule" },
		],
	},

	{
		title: "Statistics",
		icon: 'statistics',
		role: [ 0, 1, 2, 3, 4 ],
		child: [
			{
				title: "Dispatch statistics",
				link: "/statistics/dispatch-statistics"
			},
			{
				title: "Customer reports",
				link: "/statistics/customer-reports"
			},
			{
				title: "Safety RFM statistics",
				link: "/statistics/safety-statistics"
			},
		]
	},
	{
		title: "Accounting",
		icon: 'accounting',
		role: [ 0, 1, 2, 3, 4 ],
		child: [
			{ title: "Customer invoices", link: "/accounting/customer-invoices" },
			{ title: "Customer payments", link: "/accounting/customer-payments" },
			{ title: "Income transactions", link: "/accounting/income-transactions" },
			{ title: "Customer invoice items", link: "/accounting/customer-invoice-items" },
			{ title: "Company expenses", link: "/accounting/company-expenses" },
			{ title: "Billing", link: "/accounting/billing" },
			{ title: "Schedules", link: "/accounting/schedules" },
			{ title: "Scheduled payments", link: "/accounting/scheduled-payments" },
			{ title: "Short payments", link: "/accounting/shortPayments" },
			{ title: "Fuel", link: "/accounting/fuel" },
			{ title: "Drivers statements", link: "/accounting/drivers-statements" },
			{ title: "Dispatchers statements", link: "/accounting/dispatchers-st-ts" },
			{ title: "Safety statements", link: "/accounting/safety-st-ts" },
			{ title: "Manager statements", link: "/manager-statements" },
			{ title: "Bonus/charge for employee", link: "/accounting/bonus-charge" },
		],
	},
	{
		title: "Fleet",
		icon: 'inspection',
		role: [ 0, 1, 2, 3, 4 ],
		child: [
			{ title: "Work orders", link: "/work-orders", role: [ 0, 1, 2, 3, 4 ] },
			{ title: "Work orders statistics", link: "/work-orders-statistics", role: [ 0, 1, 2, 3, 4 ] },
			{ title: "Trucks on the road", link: "/trucks-on-the-road", role: [ 0, 1, 2, 3, 4 ] },
		]
	},
	{
		title: "Maintenance",
		icon: 'maintenance',
		role: [ 0, 1, 2, 3, 4 ],
		child: [
			{ title: "General", link: "/maintenance/general" },
			{ title: "Drivers", link: "/maintenance/drivers" },
			{ title: "Trucks", link: "/maintenance/trucks" },
			{ title: "Trailers", link: "/maintenance/trailers" },
			{ title: "Customers", link: "/maintenance/customers" },
			{ title: "Employees", link: "/maintenance/employees" },
			{ title: "Factoring companies", link: "/maintenance/factoring" },
			{ title: "Cities", link: "/maintenance/cities" },
			{ title: "Brokers", link: "/maintenance/brokers" },
			{ title: "Users", link: "/maintenance/users" },
			{ title: "Potential client", link: "/maintenance/potential-client" },
			{ title: "Clients", link: "/maintenance/clients" },
			{ title: "Roles", link: "/maintenance/roles" },
		]
	},
	{
		title: "Settings",
		icon: 'settings',
		role: [ 0, 1, 3, 4 ],
		child: [
			{ title: "Fleet Care settings", link: "/settings/accounting-settings" },
			{ title: "User Account Settings", link: "/settings/user-account-settings" },
			// { title: "Account settings", link: "/settings/accounting-settings" },
			// { title: "Old system settings", link: "/settings/old-system-settings" },
			{ title: "System settings", link: "/settings/system-settings" },
		],
	},
	{ title: "Log out", link: "/auth", icon: 'logOut', disabled: true },
];
